<template>
  <div>
    <!-- SHOW MODE -->
    <div v-show="!editMode" class="mt-3">
      <!-- DESCRIPTION -->
      <div v-show="!editMode">
        <Description :description="description" :comment-points="commentPoints" @toggle-edit-mode="this.$emit('toggleEditMode')" @delete-description="this.$emit('deleteDescription')" @reload="this.$emit('reload')" />
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="editMode" class="mt-3">
      <ckeditor :editor="editor" v-model="editorText" :config="editorConfig"></ckeditor>

      <div class="mt-10px">
        <button class="btn btn-primary" v-show="editMode" @click="saveDescription">
          Uložiť
        </button>

        <button class="btn btn-secondary ms-5px" v-show="editMode" @click="this.$emit('toggleEditMode');">
          Zrušiť
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import { descriptionConfig } from "../ckeditor/configs";
import Creator from "../User/Creator.vue";
import Description from "./Description.vue";

export default {
  name: "DescriptionWrapper",
  components: { Description, Creator },
  emits: ['saveDescription', 'reload', 'deleteDescription', 'toggleEditMode'],
  props: {
    description: Object,
    editMode: Boolean,
    commentPoints: Number,
  },
  data() {
    return {
      editorText: '',
      editor: ClassicEditor,
      editorConfig: descriptionConfig,
    }
  },
  watch: {
    description(newDescription) {
      if (newDescription && !this.editMode) {
        this.editorText = newDescription.text;
      }
    }
  },
  methods: {
    saveDescription() {
      const data = {
        id: this.description.id,
        text: this.editorText
      }

      this.$emit('saveDescription', data);
    }
  },
  mounted() {
    this.editorText = this.description.text;
  }
}
</script>
